
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Clock, Calendar, AlertCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

const PaymentPending = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Get payment status from URL params
    const paymentId = searchParams.get('payment_id');
    const status = searchParams.get('status');
    const externalReference = searchParams.get('external_reference');

    console.log('Payment pending page params:', { paymentId, status, externalReference });

    toast.info('Pagamento pendente', { 
      description: 'Seu pagamento está sendo processado. Aguarde a confirmação.' 
    });
  }, [searchParams]);

  return (
    <div className="max-w-2xl mx-auto space-y-8 animate-fade-in">
      <div className="text-center">
        <Clock className="h-16 w-16 text-yellow-600 mx-auto mb-4" />
        <h1 className="text-3xl font-bold text-yellow-600">Pagamento Pendente</h1>
        <p className="text-muted-foreground mt-2">
          Seu pagamento está sendo processado
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Clock className="h-5 w-5 text-yellow-600" />
            Processando Pagamento
          </CardTitle>
          <CardDescription>
            Aguarde enquanto processamos seu pagamento
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
            <h3 className="font-medium text-yellow-800 mb-2">O que está acontecendo?</h3>
            <ul className="text-sm text-yellow-700 space-y-1">
              <li>• Seu pagamento está sendo verificado</li>
              <li>• Você receberá uma confirmação em breve</li>
              <li>• Não é necessário fazer nada no momento</li>
              <li>• O processo pode levar alguns minutos</li>
            </ul>
          </div>

          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <AlertCircle className="h-5 w-5 text-yellow-600" />
              <span className="text-sm">
                Você receberá um e-mail assim que o pagamento for confirmado
              </span>
            </div>
            <div className="flex items-center gap-3">
              <Calendar className="h-5 w-5 text-primary" />
              <span className="text-sm">
                Sua consulta será confirmada automaticamente após a aprovação
              </span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button asChild className="flex-1">
              <Link to="/patient-dashboard">
                Ver Minhas Consultas
              </Link>
            </Button>
            <Button variant="outline" asChild className="flex-1">
              <Link to="/schedule">
                Agendar Nova Consulta
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentPending;
